import { useNavigate } from 'react-router-dom';
import AppPanel from './AppPanel.js';
import { LogoContainer } from './TrillionsPanel.styles.js';

export default function TrillionsPanel() {
    const navigate = useNavigate();

    return (
        <div onClick={() => navigate("/281-474-976-710-656")} style={{ width: '100%', height: '100%' }}>
            <AppPanel title={"281,474,976,710,656"} releaseDate={"JUN '24"}>
                <LogoContainer>
                    <div className='gradientBG' />
                    <div className="texts-container">
                        <h1 id="top"><em>presence</em></h1>
                        <h1 id="mid"><em>presence</em></h1>
                        <h1 id="bot"><em>presence</em></h1>
                    </div>
                </LogoContainer>
            </AppPanel>
        </div>
    );
}
